import React from 'react';
import PropTypes from 'prop-types';

import PageHeroMedia from '@common/components/PageHeroMedia';
import HTMLRenderer from '@common/components/CMSComponents/HTMLRenderer';
import PageLeadTitle from '@common/components/PageLeadTitle';
import PageLeadDescription from '@common/components/PageLeadDescription';
import ContentWrapper from '@common/components/ContentWrapper';
import { videoShape } from '@common/types/cms';

const HeroSection = ({
  lead,
  title,
  image,
  video,
  videoDesktop,
  noSpacing,
}) => (
  <React.Fragment>
    {image?.src && (
      <PageHeroMedia image={image} video={video} videoDesktop={videoDesktop} />
    )}
    <ContentWrapper>
      <PageLeadTitle isFullWidth={!image?.src}>
        <HTMLRenderer customAs="span" html={title} nl2br />
      </PageLeadTitle>
      {lead && (
        <PageLeadDescription noSpacing={noSpacing}>
          <HTMLRenderer customAs="span" html={lead} nl2br />
        </PageLeadDescription>
      )}
    </ContentWrapper>
  </React.Fragment>
);

HeroSection.propTypes = {
  title: PropTypes.string.isRequired,
  lead: PropTypes.string,
  image: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string,
  }),
  video: videoShape,
  videoDesktop: videoShape,
  noSpacing: PropTypes.bool,
};

HeroSection.defaultProps = {
  image: null,
  video: null,
  videoDesktop: null,
  lead: null,
  noSpacing: false,
};

export default HeroSection;
